import { useRef, type ReactNode } from "react";
import { ChevronRight } from "lucide-react";
import { cx } from "./cx.js";

export interface DisclosureProps {
  label: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
  onOpenChange?: (open: boolean) => void;
}

/** Native progressive disclosure that keeps its children mounted between toggles. */
export function Disclosure({ label, children, defaultOpen = false, className, onOpenChange }: DisclosureProps) {
  const ref = useRef<HTMLDetailsElement>(null);
  return (
    <details
      ref={ref}
      className={cx("disclosure", className)}
      open={defaultOpen || undefined}
      onToggle={event => onOpenChange?.(event.currentTarget.open)}
      onInvalidCapture={() => {
        if (ref.current) ref.current.open = true;
      }}
    >
      <summary className="disclosure__summary"><ChevronRight className="disclosure__chevron" size={16} aria-hidden="true" />{label}</summary>
      <div className="disclosure__content">{children}</div>
    </details>
  );
}
